import type {
  StaffCreateRequest,
  StaffListResponse,
  StaffSaveResponse,
  StaffUpdateRequest,
} from '@/api/types'
import { apiRequest } from '@/api/client'

export const staffApi = {
  list: (restaurantId?: number) =>
    apiRequest<StaffListResponse>(
      `/api/v0/admin/staff${restaurantId ? `?restaurantId=${restaurantId}` : ''}`,
    ),
  create: (data: StaffCreateRequest) =>
    apiRequest<StaffSaveResponse>('/api/v0/admin/staff', {
      method: 'POST',
      body: JSON.stringify(data),
    }),
  update: (id: string, data: StaffUpdateRequest) =>
    apiRequest<StaffSaveResponse>(`/api/v0/admin/staff/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    }),
}
